import $ from 'jquery';

/* Slick Slider on mobile product page */
export default class SlickSlider {
  init() {
    $('.product-mobile-slider').each(function() {
      var $carousel = $(this);
      /* Initializes a slick carousel only on mobile screens */
      // slick on mobile
      if ($(window).width() > 992) {
        if ($carousel.hasClass('slick-initialized')) {
          $carousel.slick('unslick');
        }
      }
      else {
        if (!$carousel.hasClass('slick-initialized')) {
          $carousel.slick({
            arrows: false,
            dots: true,
            touchThreshold: 8,
            speed: 200,
          })
        }
      }
    })
  }
}
